export const filtersToQueryString = (
  filters: Array<{ name: string; value: any; operation: string }>
): string => {
  return filters
    .filter((f) => f.value !== undefined && f.value !== null && f.value !== "")
    .map((f) => {
      return `${encodeURIComponent(f.name)}=${encodeURIComponent(
        JSON.stringify({ value: f.value, op: f.operation })
      )}`;
    })
    .join("&");
};
export const getFiltersFromURL = (): Array<{
  name: string;
  value: any;
  operation: string;
}> => {
  const search =
    window.location.search || window.location.hash.split("?")[1] || "";
  const params = new URLSearchParams(search);
  const filters: Array<{ name: string; value: any; operation: string }> = [];

  for (const [key, value] of Array.from(params.entries())) {
    if (["keyword", "page", "perPage"].includes(key)) continue;

    try {
      const decoded = JSON.parse(decodeURIComponent(value));
      filters.push({
        name: key,
        value: decoded.value,
        operation: decoded.op || "eq",
      });
    } catch (e) {
      filters.push({
        name: key,
        value: decodeURIComponent(value),
        operation: "eq",
      });
    }
  }

  return filters;
};
export const addSearchToURL = (keyword: string | undefined) => {
  const url = new URL(window.location.href);
  if (keyword) {
    url.searchParams.set("keyword", keyword);
  } else {
    url.searchParams.delete("keyword");
  }
  window.history.replaceState(null, "", url.toString());
};

export const getKeywordFromURL = () => {
  const params = new URLSearchParams(location.search);
  return params.get("keyword") || undefined;
};

export const getPageFromURL = (): number | undefined => {
  const params = new URLSearchParams(window.location.search);
  const page = params.get("page");
  return page ? parseInt(page) : undefined;
};

export const getPerPageFromURL = (): number | undefined => {
  const params = new URLSearchParams(window.location.search);
  const perPage = params.get("perPage");
  return perPage ? parseInt(perPage) : undefined;
};

export const addPaginationToURL = (page?: number, perPage?: number) => {
  const params = new URLSearchParams(window.location.search);
  if (page !== undefined) params.set("page", String(page));
  if (perPage !== undefined) params.set("perPage", String(perPage));
  const newUrl = `${window.location.pathname}?${params.toString()}`;
  window.history.replaceState({}, "", newUrl);
};
